import { Chip } from "@nextui-org/react";

interface SeverityChipProps {
  severity: "Critical" | "High" | "Medium" | "Low";
}

export function SeverityChip({ severity }: SeverityChipProps) {
  const severityConfig = {
    Critical: {
      bg: "#FECACA",
      color: "#991B1B",
    },
    High: {
      bg: "#FDD0DF",
      color: "#F31260",
    },
    Medium: {
      bg: "#FEF3C7",
      color: "#D97706",
    },
    Low: {
      bg: "#D1FAE5",
      color: "#065F46",
    },
  };

  const config = severityConfig[severity];

  return (
    <Chip
      size="sm"
      className="h-5 px-3"
      style={{
        backgroundColor: config.bg,
        color: config.color,
      }}
    >
      {severity}
    </Chip>
  );
}
